import { render, staticRenderFns } from "./ActiviteReservee.vue?vue&type=template&id=0fff12f5&scoped=true"
import script from "./ActiviteReservee.vue?vue&type=script&lang=js"
export * from "./ActiviteReservee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff12f5",
  null
  
)

export default component.exports